import { ApiService } from 'src/app/services/api.service';
import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

import SwiperCore, { SwiperOptions,  Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);
declare var $: any; // If you're using jQuery



@Component({
  selector: 'app-home-one',
  templateUrl: './home-one.component.html',
  styleUrls: ['./home-one.component.scss']
})
export class HomeOneComponent implements OnInit {
  featuredJobs: any[] = [];
  organizations: any[] = []; // Initialize to an empty array
  isLoadingJobs: boolean = true;



  swiperBreakpoints = {
    300: { slidesPerView: 1, spaceBetween: 20 },
    768: { slidesPerView: 2, spaceBetween: 20 },
    1024: { slidesPerView: 4, spaceBetween: 30 }
  };

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.loadFeaturedJobs();
    
    this.apiService.getAllOrganizations().subscribe(
      data => {
        this.organizations = data;
      },
      error => {
        console.error('Error fetching organizations', error);
      }
    );
  }

  loadFeaturedJobs(): void {
    this.isLoadingJobs = true; // Start loading
    this.apiService.getFeaturedJobs().subscribe({
      next: (jobs) => {
        this.featuredJobs = jobs;
        this.isLoadingJobs = false; // Finish loading
      },
      error: (error) => {
        console.error('Error fetching featured jobs:', error);
        this.isLoadingJobs = false; // Finish loading even in case of error
      }
    });
  }
}
